import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import { CognitoUtil } from '../../services/cognito.service';
import { Router } from '@angular/router';
import { UserLoginService } from '../../services/user-login.service';
import { uiSelectors } from '../../store/selectors';
import { IRootState } from '../../store/reducers';

@Component({
  selector: 'app-rootbar',
  templateUrl: './rootbar.component.html',
  styleUrls: ['./rootbar.component.scss']
})
export class RootbarComponent implements OnInit {
  logged$: Observable<boolean>;
  user$: Observable<any>;

  public groups: string[] = [];
  public appsBitmask: number;
  public appsAuthMap = {
    admin: false,
    planner: false,
    reporting: false,
    dashboard: false
  };

  constructor(
    public cognitoUtil: CognitoUtil,
    public router: Router,
    private store: Store<IRootState>,
    private userLoginService: UserLoginService
  ) {}

  ngOnInit() {
    this.logged$ = this.store.select(uiSelectors.getLogged);
    this.user$ = this.store.select(uiSelectors.getCurrentUser);

    // this.cognitoUtil.getAuthData().then(res => {
    //   if (res) {
    //     this.groups = res.groups;
    //     this.appsBitmask = parseInt(res.apps, 10);
    //     if (this.groups.includes('administrators')) {
    //       this.appsAuthMap = {
    //         admin: true,
    //         planner: true,
    //         reporting: true,
    //         dashboard: true
    //       };
    //     } else if (this.groups.includes('users')) {
    //       this.appsAuthMap = {
    //         admin: this.userLoginService.isUserAppAuthorized(
    //           this.userLoginService.getAppAuthValue('Admin Application'),
    //           this.appsBitmask
    //         ),
    //         planner: this.userLoginService.isUserAppAuthorized(
    //           this.userLoginService.getAppAuthValue('Planner Application'),
    //           this.appsBitmask
    //         ),
    //         reporting: this.userLoginService.isUserAppAuthorized(
    //           this.userLoginService.getAppAuthValue('Reporting Application'),
    //           this.appsBitmask
    //         ),
    //         dashboard: this.userLoginService.isUserAppAuthorized(
    //           this.userLoginService.getAppAuthValue('Dashboard Application'),
    //           this.appsBitmask
    //         )
    //       };
    //     }
    //   }
    // });
  }

  appNameFromPath(path: string) {
    switch (path) {
      case '':
        return 'Zoom Suite Homepage';
      case 'admin':
        return 'Admin Application';
      case 'planner':
        return 'Planner Application';
      case 'reporting':
        return 'Reporting Application';
      case 'dashboard':
        return 'Dashboard Application';
    }
  }

  navigateTo(path) {
    const basePath = path.split('/')[0];
    switch (basePath) {
      case 'admin':
        if (this.appsAuthMap.admin) {
          window.open('/' + path, '_self');
        }
        break;
      case 'planner':
        if (this.appsAuthMap.planner) {
          window.open('/' + path, '_self');
        }
        break;
      case 'reporting':
        if (this.appsAuthMap.reporting) {
          window.open('/' + path, '_self');
        }
        break;
      case 'dashboard':
        if (this.appsAuthMap.dashboard) {
          window.open('/' + path, '_self');
        }
        break;
    }
  }

  navigateToHelpFromPath(path: string) {
    switch (path) {
      case 'planner':
        this.navigateTo(path + '/help');
        break;
      case '':
      case 'admin':
      case 'reporting':
      case 'dashboard':
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/rootbar/rootbar.component.ts